module.exports = __webpack_public_path__ + "img/rms-mnu-logo.49c00002.png";